import { createLoader, parseAsArrayOf, parseAsStringEnum } from 'nuqs/server';

enum ObjectTypes {
  Apartment = 'Lägenhet',
  House = 'Hus',
  VacationHome = 'Fritidshus',
  Farms = 'Gård',
  PlotsOfLand = 'Tomt/Mark',
  Other = 'Övrigt',
}

const DEFAULT_OBJECT_TYPES = [ObjectTypes.Apartment, ObjectTypes.House, ObjectTypes.VacationHome, ObjectTypes.Farms];

const ALL_OBJECT_TYPES: ObjectTypes[] = Object.values(ObjectTypes);

const createKeyMaps = (defaults: ObjectTypes[] = DEFAULT_OBJECT_TYPES) => ({
  objectType: parseAsArrayOf(parseAsStringEnum(Object.values(ObjectTypes))).withDefault(defaults),
});

const keyMaps = createKeyMaps();
const urlKeys = {
  objectType: 'object-type',
};
const objectTypeLoader = (defaults: ObjectTypes[]) => createLoader(createKeyMaps(defaults), { urlKeys });

export { ALL_OBJECT_TYPES, createKeyMaps, DEFAULT_OBJECT_TYPES, keyMaps, ObjectTypes, objectTypeLoader, urlKeys };
